let partner_location = window.location.hostname.replace(/.unionex.market/, '');
export default {
  SITE_NAME: `${partner_location.toUpperCase()}`,
  GOOGLE_ANALYTICS_SITE_CODE: 'UA-150740614-1',
  GOOGLE_RECAPTCHA_CODE: '6Ld-360UAAAAAO7YexY9ejF2AeEWTF4f5CZGz2eq',
  ORDERBOOK_VIEW_COUNT: 10, // 호가창에서 보여줄 주문 갯수 (매수, 매도 별도)
  API_BASE_URL: 'https://gb.unionex.market',
  MINING_COIN: 'uniex',
  MAIN_HOST_URL: `https://${partner_location}.unionex.market`,
  MAIN_OLD_HOST_URL: `https://${partner_location}.unionex.market`,
  SOCKET_BASE_URL: '',
  STATIC_BASE_URL: `https://static.unionex.market`,
  STATIC_PARTNER_BASE_URL: `https://static.unionex.market/__${partner_location}`,
  TOAST: {
    DEFAULT_LAST_SECOND: 3 * 1000, // 토스트 기본 지속 시간
    DEFAULT_POSITION: 'tr' // 토스트 위치 (reapop 참고)
  },
  UP_EXCHANGE_RATE: 1
};
